import { render, staticRenderFns } from "./Vezba.vue?vue&type=template&id=f130e264&"
import script from "./Vezba.vue?vue&type=script&lang=js&"
export * from "./Vezba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports